export default __webpack_public_path__ + "static/media/icon2.9db61ad6.svg";